import * as React from "react";
const SettingsIcon = ({ props }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.183 1.667h-.366A1.667 1.667 0 0 0 8.15 3.333v.15a1.67 1.67 0 0 1-.833 1.442l-.359.208a1.67 1.67 0 0 1-1.666 0l-.125-.067a1.667 1.667 0 0 0-2.275.609l-.184.317a1.667 1.667 0 0 0 .609 2.275l.125.083a1.67 1.67 0 0 1 .833 1.433v.425a1.67 1.67 0 0 1-.833 1.45l-.125.075a1.667 1.667 0 0 0-.609 2.275l.184.317a1.667 1.667 0 0 0 2.275.608l.125-.066a1.67 1.67 0 0 1 1.666 0l.359.208a1.67 1.67 0 0 1 .833 1.442v.15a1.667 1.667 0 0 0 1.667 1.666h.366a1.666 1.666 0 0 0 1.667-1.666v-.15a1.67 1.67 0 0 1 .833-1.442l.359-.208a1.67 1.67 0 0 1 1.666 0l.125.066a1.667 1.667 0 0 0 2.275-.608l.184-.325a1.667 1.667 0 0 0-.609-2.275l-.125-.067a1.67 1.67 0 0 1-.833-1.45v-.417a1.67 1.67 0 0 1 .833-1.45l.125-.074a1.667 1.667 0 0 0 .609-2.275l-.184-.317a1.667 1.667 0 0 0-2.275-.609l-.125.067a1.67 1.67 0 0 1-1.666 0l-.359-.208a1.67 1.67 0 0 1-.833-1.442v-.15a1.667 1.667 0 0 0-1.667-1.666"
      stroke={
        window.location.pathname.includes("/home/settings")
          ? "#ffffff"
          : "#667085"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      stroke={
        window.location.pathname.includes("/home/settings")
          ? "#ffffff"
          : "#667085"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SettingsIcon;
